<template>
<div class="col-md-12 col-sm-12 col-xs-12 info-form-content p-l-r-0">
    <!-- <a href="#" class="preview " id="partnershippreview-btn" v-on:click="ifpreviewopen2()">
        <img src="../assets/privew-icon.png">
    </a>
    <a href="#" class="preview preview_btn-width" id="partnershippreview-close-btn" v-on:click="ifpreviewclose2()" style="display: none;">
        <img src="../assets/close-icon.png">
    </a> -->
    <div class="partnership_form_block" id="partnership_form_block" v-if="form_status">
        <div class="accordion_partner" id="accordion_partner" role="tablist">
            <b-card no-body class="mb-1" v-for="(f,key) in directors" :key="key">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="'accordionpartner-' + key" variant="info">Partner - {{key+1}} Details<span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse :id="'accordionpartner-'+key" visible accordion="partner-accordion" role="tabpanel">
                    <b-card-body>
                        <form>
                            <!-- <div class="col-md-12 p-l-r-0 f-left text-right edit_icon" style="margin-bottom: 0px">
                                <a href="#"><img src="../assets/edit_icon.png"></a>
                            </div> -->
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="name">Name (in full)*</label>
                                    <input type="text" class="form-control" id="name" v-model="f.name">
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.name">Please enter name</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="mobile_no">Mobile Number*</label>
                                    <input type="text" class="form-control" id="mobile_no" v-model="f.mobile_no">
                                    <span class="teptext">(Linked with Aadhar)</span>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.mobile_no">{{validation_errors.mobile_no}}</span>
                                </div>
                            </div>

                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="email_id">Email ID*</label>
                                    <input type="text" class="form-control" id="email_id" v-model="f.email_id">
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.email_id">{{validation_errors.email_id}}</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="Birth">Date of Birth*</label>
                                    <!-- <input type="text" class="form-control" id="Birth" v-model="f.dob"> -->
                                    <Datepicker class="form-control" v-model="f.dob"></Datepicker>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.dob">Please select date of birth</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Contribution">Capital Contribution (INR)*</label>
                                    <input type="text" class="form-control" id="Contribution" v-model="f.capital_contribution">
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.capital_contribution">Please enter capital contribution</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="Ratio">Profit Sharing Ratio (%)*</label>
                                    <input type="text" class="form-control" id="Ratio" v-model="f.profit_sharing_ratio">
                                    <span class="text-danger" v-if="presentKey==key && validation_errors.profit_sharing_ratio">Please enter profit sharing ratio</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="panNumber">PAN Number*</label>
                                    <input type="text" class="form-control" id="panNumber" v-model="f.pan_number">
                                    <span class="text-danger" v-if="presentKey==key && validation_errors.pan_number">Please enter pan number</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="address">Address*</label>
                                    <textarea class="form-control form_textarea" rows="4" id="address" v-model="f.address"></textarea>
                                     <span class="text-danger" v-if="presentKey==key && validation_errors.address">Please enter address</span>
                                     
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left proof_upload">
                                <div class="col-md-12 p-l-r-0 f-left">
                                    <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                        <pan_upload v-bind:propdata="props_from_parent" v-bind:from_key="key" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="f.pan_url">
                                            <a :href="f.pan_url" target="_blank">View</a>
                                        </span>
                                         <span class="text-danger" v-if="presentKey==key && validation_errors.pan_url">Please update self-attested PAN document</span>
                                    </div>
                                    <div class="form-group col-md-6 p-l-r-0 f-left choosefile-upload">
                                        <aadhar_upload v-bind:propdata="props_from_parent" v-bind:from_key="key" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="f.aadhar_url">
                                            <a :href="f.aadhar_url" target="_blank">View</a>
                                        </span>
                                        <span class="text-danger" v-if="presentKey==key && validation_errors.aadhar_url">Please update self-attested Aadhar document</span>
                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                        <photo_upload v-bind:propdata="props_from_parent" v-bind:from_key="key" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="f.passport_size_photo">
                                            <a :href="f.passport_size_photo" target="_blank">View</a>
                                        </span>
                                        <span class="text-danger" v-if="presentKey==key && validation_errors.passport_size_photo">Please update passport size photo</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <proof_upload :parentName="'partnership'"/> -->

                            <div class="col-md-12 p-l-r-0 f-left ">
                                <br>
                                <button type="button" class="btn btn-primary gobtn submit" @click="Submit(key)">
                                    <span v-if="key < directors_count-1 ">
                                        Next
                                    </span>
                                    <span v-else>
                                        Submit
                                    </span>
                                </button>
                                <br><br>
                            </div>
                        </form>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordionpartner-3 variant="info">Other Details <span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse id="accordionpartner-3" accordion="partner-accordion" role="tabpanel" class="other_details-sec">
                    <b-card-body>
                        <form>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Website">Website (if available)*</label>
                                    <input type="text" class="form-control" id="Website" v-model="other_details.website">
                                    <!-- <span class="text-danger" v-if="other_validation.website">Enter website name</span> -->
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Partnership">Name of the Partnership*</label>
                                    <input type="text" class="form-control" id="Partnership" v-model="other_details.name">
                                    <span class="teptext">Under which you would like to carry your business</span>
                                    <span class="text-danger" v-if="other_validation.name">Enter name of the partnership</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="Brand">Brand name (if any)*</label>
                                    <input type="text" class="form-control" id="Brand" v-model="other_details.brand">
                                    <span class="teptext">(Trade name, if any) under which you would like to carry your business</span>
                                    
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-12 p-l-r-0 nospace f-left">
                                    <label for="Website">Any specific points to be included in the partnership deed*</label>
                                    <textarea id="Website" rows="4" class="form-control text-area" v-model="other_details.partnership_deed"></textarea>
                                    <span class="text-danger" v-if="other_validation.partnership_deed">Enter name of the partnership</span>
                                </div>
                            </div>

                            <bills_agreement :parentName="'partnershipagreement'" :propdata="props_from_parent" :owner_information="child_prop_data" :other_validation="other_validation" @UpdateFilePath="OtherFilePath" />

                            <div class="col-md-12 p-l-r-0 f-left ">
                                <br>
                                <button type="button" class="btn btn-primary gobtn submit" @click="OtherDetailsSubmit()">Submit</button>
                            </div>
                        </form>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
    <div v-else class="partnership_form_priview_block priview_block" id="partnership_form_priview_block">
        <partnership_form_preview :prop_owners="directors" :prop_others="other_details" />
    </div>
</div>
</template>

<script>
// import proof_upload from './proof_upload';
import company_info from "../services/company_info"
import aadhar_upload from './aadhar_upload';
import photo_upload from './photo_upload';
import pan_upload from './pan_upload';
import bills_agreement from './bills_agreement';
import partnership_form_preview from './partnership_form_preview';
import Datepicker from 'vuejs-datepicker';
export default {
    name: 'partnership_firm_accordion',
    props: ['no_of_directors', 'subscription_params'],
    watch: {
        subscription_params: {
            handler: function () {
                this.InitPrepareForm();
            },
            immediate: true
        },
        no_of_directors: function (data) {
            this.directors_count = data.dir
            this.InitPrepareForm();
        },
    },
    components: {
        // proof_upload,
        bills_agreement,
        partnership_form_preview,
        aadhar_upload,
        pan_upload,
        photo_upload,
        Datepicker
    },
    data() {
        return {
            form_status: true,
            presentKey:'',
            directors_count: 2,
            validation_errors: {
            },
            other_validation: {
            },
            props_from_parent: {
                subscribtion_id: '',
                folder_id: '',
                type: ''
            },
            child_prop_data: {
                registered_office: '',
                rental_url: '',
                any_utility_bill_url: '',
                noc: ''
            },
            other_details: {
                subscription_id: this.subscription_params.subscribtion_id,
                website: '',
                entity: 'PSF',
                partnership_deed: '',
                name: '',
                bran_name: '',
                any_utility_bill_url: '',
                noc: '',
                registered_office_doc_url: '',
                registered_office: '',

            },
            directors: [],

        }
    },
    methods: {
        InitPrepareForm() {
            this.directors_count = this.no_of_directors.dir;
            this.directors = [];
            var db_params = this.subscription_params.company_info;
            if (db_params) {
                this.form_status = db_params.status == 'pending' ? true : false;
                if (db_params.other_details) {
                    this.other_details = JSON.parse(db_params.other_details);
                }
                var res_format = JSON.parse(db_params.onwer_information);
                if (res_format.length>0) {
                    for (var j = 0; j < db_params.no_of_owners; j++) {
                        this.directors.push(res_format[j]);
                    }

                } else {
                    this.prePareForm();
                }
            } else {
                this.prePareForm();
            }

            this.UpdateChildPropData();
        },
        prePareForm() {
            for (var i = 1; i <= this.directors_count; i++) {
                this.directors.push({
                    name: '',
                    mobile_no: '',
                    email_id: '',
                    dob: '',
                    pan_number: '',
                    address: '',
                    capital_contribution: '',
                    profit_sharing_ratio: '',
                    aadhar_url: '',
                    pan_url: '',
                    passport_size_photo: '',
                });
            }
        },
        UpdateChildPropData() {
            this.props_from_parent = this.subscription_params
            this.props_from_parent.date = new Date()
            // to child_prop_data
            this.child_prop_data.registered_office = this.other_details.registered_office
            this.child_prop_data.registered_office_doc_url = this.other_details.registered_office_doc_url
            this.child_prop_data.any_utility_bill_url = this.other_details.any_utility_bill_url
            this.child_prop_data.noc = this.other_details.noc

        },
        UpdateFilePath(payload) {
            if (payload.src == 'aadhar_url') {
                this.directors[payload.action].aadhar_url = payload.url;
            }
            if (payload.src == 'pan_url') {
                this.directors[payload.action].pan_url = payload.url;
            }
            if (payload.src == 'passport_size_photo') {
                this.directors[payload.action].passport_size_photo = payload.url;
            }
        },
        OtherFilePath(payload) {
            if (payload.src == 'noc') {
                this.other_details.noc = payload.url;
            }
            if (payload.src == 'registered_office_doc_url') {
                this.other_details.registered_office_doc_url = payload.url;
            }
            if (payload.src == 'any_utility_bill_url') {
                this.other_details.any_utility_bill_url = payload.url;
            }
            if (payload.src == 'registered_office') {
                this.other_details.registered_office = payload.url;
            }
        },
        Submit(from) {
           this.presentKey=from
           this.validation_errors={}
            company_info.post({
                    onwer_information: this.directors[from],
                    onwer_information_all: this.directors,
                    subscription_id: this.subscription_params.subscribtion_id,
                    no_of_owners: this.no_of_directors.dir,
                    entity: 'PSF',
                    validate_index: from
                })
                .then(response => {
                    if (response.data.status == 'success') {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'success',
                            text: 'Details saved successfully',
                            ignoreDuplicates: true
                        });
                          // open next form
                         if (from < this.directors.length - 1) {
                            var accordian = from + 1
                            document.getElementById('accordion-' + accordian).style.display = 'block';
                            document.getElementById('accordion-' + from).style.display = 'none';
                        }
                    }
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'warn',
                            text: 'Please fill all required fields',
                            ignoreDuplicates: true
                        });
                        var err=error.response.data.status;
                            var temp={};
                        Object.keys(err).forEach((key) => {
                            var err_text=err[key][0].split(".");
                            temp[key.split(".")[1]]=err_text[1]
                        });
                        this.validation_errors=temp
                    }
                })
        },
        OtherDetailsSubmit() {
            company_info.postOtherDetails(this.other_details)
                .then(response => {
                    if (response.data.status == 'success') {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'success',
                            text: 'Details saved successfully',
                            ignoreDuplicates: true
                        });
                        this.$emit("saveSuccessToparent", {
                            src: 'psf'
                        });
                    }
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'warn',
                            text: 'Please fill all required fields',
                            ignoreDuplicates: true
                        });
                        var err=error.response.data.status;
                        var temp={};
                        Object.keys(err).forEach((key) => {
                            temp[key]=err[key][0]
                        });
                        this.other_validation=temp
                    }
                })
        },
        ifpreviewopen2() {
            document.getElementById('partnership_form_priview_block').style.display = 'block';
            document.getElementById('partnership_form_block').style.display = 'none';
            document.getElementById('partnershippreview-btn').style.display = 'none';
            document.getElementById('partnershippreview-close-btn').style.display = 'block';
        },
        ifpreviewclose2() {
            document.getElementById('partnership_form_priview_block').style.display = 'none';
            document.getElementById('partnership_form_block').style.display = 'block';
            document.getElementById('partnershippreview-btn').style.display = 'block';
            document.getElementById('partnershippreview-close-btn').style.display = 'none';
        }
    }
};
</script>
